import { render, staticRenderFns } from "./ArticleNotificationOrder.vue?vue&type=template&id=106c3936"
import script from "./ArticleNotificationOrder.vue?vue&type=script&lang=js"
export * from "./ArticleNotificationOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports